import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FontType, FontWeight, TextAlign } from '@freelancer/ui/text';

@Component({
  selector: 'app-groups-empty-state-cta',
  template: ` <ng-content></ng-content> `,
})
export class GroupsGenericEmptyStateCTAComponent {}

@Component({
  selector: 'app-groups-generic-empty-state',
  template: `
    <fl-picture
      [src]="imgSrc"
      [alt]="imgAlt"
    ></fl-picture>

    <ng-container *ngIf="oneLineMessage; else multiLineMessage">
      <fl-text [textAlign]="TextAlign.CENTER">
        {{ primaryMessage }}

        <fl-text
          *ngIf="secondaryMessage"
          [fontType]="FontType.SPAN"
          [weight]="FontWeight.BOLD"
        >
          {{ secondaryMessage }}
        </fl-text>
      </fl-text>
    </ng-container>

    <ng-template #multiLineMessage>
      <fl-text [textAlign]="TextAlign.CENTER">
        {{ primaryMessage }}
      </fl-text>

      <fl-text
        *ngIf="secondaryMessage"
        [textAlign]="TextAlign.CENTER"
        [weight]="FontWeight.BOLD"
      >
        {{ secondaryMessage }}
      </fl-text>
    </ng-template>
    <ng-content select="app-groups-empty-state-cta"></ng-content>
  `,
  styleUrls: ['./groups-generic-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupsGenericEmptyStateComponent {
  TextAlign = TextAlign;
  FontType = FontType;
  FontWeight = FontWeight;

  @Input() imgSrc: string;
  @Input() imgAlt: string;
  @Input() oneLineMessage = false;
  @Input() primaryMessage: string;
  @Input() secondaryMessage?: string;
}
